import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AboutPage.css";
import SEO from "../components/SEO";

export default function AboutPage() {
    const navigate = useNavigate();
    

  return (
    <>
      <SEO
        title="About Magyne | SaaS & ERP Platform for Africa"
        description="Learn about Magyne, a SaaS and ERP platform building specialized business management software for organizations across Africa."
        path="/about"
      />
      <main>
        <div className="about-page">

          {/* Hero Section */}
          <section className="about-hero" style={{
            backgroundImage: `
              linear-gradient(
                  rgba(15,23,42,.75),
                  rgba(15,23,42,.75)
              ),
              url(${process.env.PUBLIC_URL}/images/operations.jpg)
              `
            }}
          >
            <div className="hero-overlay">
              <h1>
                One Platform.
                <span> Multiple Solutions.</span>
              </h1>

              <p>
                Magyne ERP is the central gateway that connects businesses
                with powerful industry-specific ERP solutions.
              </p>

              <button className="hero-btn" onClick={() => navigate("/solutions")}>
                Explore Solutions
              </button>
            </div>
          </section>


          {/* Introduction */}
          <section className="about-intro">

            <div className="intro-card m-2">
              <h1>About Magyne</h1>

              <p>
                Magyne is a SaaS and enterprise resource planning platform
                designed to help organizations across Africa manage their
                operations through modern digital systems.
              </p>

              <p>
                Through a secure centralized platform, businesses can access
                specialized solutions designed around their industries while
                maintaining their own isolated and secure environments.
              </p>
            </div>

            <div className="intro-card m-2">
              <h1>What is Magyne?</h1>

              <p>
                Magyne provides a unified technology platform with specialized
                solutions for different industries and organizations.
              </p>
            </div>

            <div className="stats-container">

              <div className="stat-card">
                <h3>100%</h3>
                <p>Secure Tenant Isolation</p>
              </div>

              <div className="stat-card">
                <h3>24/7</h3>
                <p>Business Availability</p>
              </div>

              <div className="stat-card">
                <h3>∞</h3>
                <p>Expandable Solutions</p>
              </div>

            </div>

          </section>



          {/* Architecture Section */}
          <section className="architecture">

            <h2>
              Built for Modern Businesses
            </h2>

            <div className="architecture-grid">

              <div className="architecture-card">
                <div>
                  <i className="bi bi-person-lock"></i>
                </div>

                <h3>
                  Centralized Security
                </h3>

                <p>
                  One secure identity system manages user authentication and
                  access across all Magyne solutions.
                </p>

              </div>


              <div className="architecture-card">

                <div>
                  <i className="bi bi-building-lock"></i>
                </div>

                <h3>
                  Business Isolation
                </h3>

                <p>
                  Every organization operates within its own secure environment,
                  protecting business data and privacy.
                </p>

              </div>


              <div className="architecture-card">

                <div>
                  <i className="bi bi-building-up"></i>
                </div>

                <h3>
                  Scalable Platform
                </h3>

                <p>
                  New solutions can easily be added into the ecosystem without
                  affecting existing businesses.
                </p>

              </div>


            </div>

          </section>


          {/* Vision */}
          <section className="vision-section">

            <h2>
              Our Vision
            </h2>

            <p>
              To empower businesses across Africa and beyond with affordable,
              intelligent, and connected digital solutions that simplify
              everyday operations.
            </p>


          </section>


        </div>
      </main>
    </>
  );
}